var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93397 8.77881C3.7134 10.5478 6.8167 12.9999 10.3474 12.9999C13.878 12.9999 16.9807 10.5478 18.7601 8.77881C19.2294 8.31226 19.4649 8.07819 19.6143 7.62012C19.7209 7.29328 19.7209 6.70674 19.6143 6.3799C19.4649 5.92181 19.2295 5.6877 18.7601 5.22111C16.9807 3.45208 13.878 1 10.3474 1C6.8167 1 3.7134 3.45208 1.93397 5.22111C1.46431 5.68802 1.22945 5.92165 1.07996 6.3799C0.973345 6.70673 0.973345 7.29328 1.07996 7.62012C1.22945 8.07837 1.4643 8.31189 1.93397 8.77881Z",
    stroke: "#B6B7B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34717 7C8.34717 8.10457 9.2426 9 10.3472 9C11.4517 9 12.3472 8.10457 12.3472 7C12.3472 5.89543 11.4517 5 10.3472 5C9.2426 5 8.34717 5.89543 8.34717 7Z",
    stroke: "#B6B7B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f7d0f3e312895c3a9023861051220f3b.svg";
export { ForwardRef as ReactComponent };